import { Link } from "react-router-dom";
import { InstagramIcon } from "../common/icons/icons";

export const Footer = () => {
  return (
    <footer className="border-t border-border py-12 px-4 sm:px-6 lg:px-8 bg-card">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 mb-8 text-center md:text-left">
          <div>
            <h3 className="font-light italic text-2xl text-primary mb-4">
              The Blind Date
            </h3>
            <p className="text-foreground/60 text-sm">
              Real conversations begin here.
            </p>

            <div className="mt-4 flex justify-center md:justify-start">
              <a
                href="https://www.instagram.com/theblinddate.in?igsh=MWcwZmV2MDRva2x5ZA=="
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="text-foreground/60 hover:text-primary transition"
              >
                <InstagramIcon />
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-foreground">Product</h4>
            <ul className="space-y-2 text-sm text-foreground/60">
              <li>
                <Link
                  to="/how-it-works"
                  className="hover:text-primary transition"
                >
                  How It Works
                </Link>
              </li>
              <li>
                <Link to="/admin" className="hover:text-primary transition">
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-foreground">Company</h4>
            <ul className="space-y-2 text-sm text-foreground/60">
              <li>
                <Link to="/about" className="hover:text-primary transition">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-primary transition">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-foreground">Legal</h4>
            <ul className="space-y-2 text-sm text-foreground/60">
              <li>
                <Link
                  to="/privacy#privacy"
                  className="hover:text-primary transition"
                >
                  Privacy
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy#terms"
                  className="hover:text-primary transition"
                >
                  Terms
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border pt-8 text-center text-sm text-foreground/60">
          <p>
            &copy; {new Date().getFullYear()} The Blind Date. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
